import script from "./LingoStudentGrammarKC.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoStudentGrammarKC.vue?vue&type=script&setup=true&lang=ts"

import "./LingoStudentGrammarKC.vue?vue&type=style&index=0&id=7a96b380&lang=scss&scoped=true"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a96b380"]])

export default __exports__